import './RecruitmentProcess.scss';
import { $, SlickSlider } from "../../../common/scripts/Libs";

class RecruitmentProcess {

  constructor(node) {
    this.node = node;
    this.spnav = null;
  }

  init() {

    this.spnav = $(this.node).find('.steps-process__nav').slick({
      slidesToShow: 1,
      infinite: false,
      arrows: false,
      asNavFor: '.steps-process__for',
      focusOnSelect: true,
      centerMode: true,
      speed: 300,
      variableWidth: true,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.5,
          }
        }
      ]
    }, SlickSlider);

    $(this.node).find('.steps-process__for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      fade: true,
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      asNavFor: '.steps-process__nav',
      touchThreshold: 100
    }, SlickSlider);

    var tabsTrack = $(this.node).find('.steps-process__nav .slick-track');

    tabsTrack.addClass("removeTransform");

    this.spnav.on('beforeChange', function (event, slick, currentSlide) {
      if (currentSlide > 0) {
        tabsTrack.removeClass("removeTransform");
      } else {
        tabsTrack.addClass("removeTransform");
      }
    });

  }

}

JSModules['RecruitmentProcess'] = RecruitmentProcess;
export default RecruitmentProcess;
